import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import BaselineCosts from "components/UnifiedProject/RealityCheck/BaselineCosts";

import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";

class BaselineCostsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { id } = this.props;

    return <BaselineCosts {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const retId = ownProps.runId;

  return {
    updateBaselineConversionGain: (conversionGain) => {
      dispatch(setupReducer.updateBaselineConversionGain(retId, conversionGain));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineConversionCost: (conversionCost) => {
      dispatch(setupReducer.updateBaselineConversionCost(retId, conversionCost));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineConversionMissed: (conversionMissed) => {
      dispatch(setupReducer.updateBaselineConversionMissed(retId, conversionMissed));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineConversionSaved: (conversionSaved) => {
      dispatch(setupReducer.updateBaselineConversionSaved(retId, conversionSaved));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineCustomValue: (blueprintId, customKey, customValue) => {
      dispatch(setupReducer.updateBaselineCustomValue(retId, blueprintId, customKey, customValue));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    removeBaselineCustomValues: (blueprintId) => {
      dispatch(setupReducer.removeBaselineCustomValues(retId, blueprintId));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const runId = ownProps.runId;

  return {
    setup: setupReducer.getSetup(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(BaselineCostsContainer);
